import * as S from './ResolveSwapOrReturn.styles'
import ResolveSwapOrReturnContainer from '../../components/ResolveSwapOrReturnContainer'

export const ResolveSwapOrReturn = () => (
  <S.Wrapper>
    <ResolveSwapOrReturnContainer />
  </S.Wrapper>
)
